import { render, staticRenderFns } from "./SendMailModal.vue?vue&type=template&id=13ced23f&scoped=true&"
import script from "./SendMailModal.vue?vue&type=script&lang=js&"
export * from "./SendMailModal.vue?vue&type=script&lang=js&"
import style0 from "./SendMailModal.vue?vue&type=style&index=0&id=13ced23f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ced23f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ced23f')) {
      api.createRecord('13ced23f', component.options)
    } else {
      api.reload('13ced23f', component.options)
    }
    module.hot.accept("./SendMailModal.vue?vue&type=template&id=13ced23f&scoped=true&", function () {
      api.rerender('13ced23f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modals/SendMailModal.vue"
export default component.exports